import PropTypes from 'prop-types';
import React, {Fragment, Component} from 'react';
import LazyComponent from '../LazyComponent/LazyComponent';
import * as ReactIs from 'react-is';

export default class LazyPanels extends Component {
  constructor(props) {
    super(props);

    this.onLoad = this.onLoad.bind(this);
  }

  onLoad(panelDef) {
    const {onLoad} = this.props;
    if (onLoad) {
      onLoad(panelDef);
    }
  }

  render() {
    const {panels} = this.props;

    return (
      <Fragment>
        {panels.map((panelDef, index) => {
          const req = require.context('crazyEditor', true, /^\.\/.*\.js/);
          const panelClass = req(`./${panelDef.panelName}.js`);
          return (
            <LazyComponent
              key={`panel${index}`}
              componentClass={ReactIs.isValidElementType(panelClass) ? panelClass : panelClass.default}
              componentProps={panelDef}
              onLoad={this.onLoad.bind(this, panelDef)}
            />
          );
        })}
      </Fragment>
    );
  }
}

LazyPanels.propTypes = {
  panels: PropTypes.array.isRequired,
  onLoad: PropTypes.func,
};

LazyPanels.defaultProps = {
  panels: [],
};
